import { FlowNotableObject } from 'flow-schema';

import { api } from 'common';

import { GetNotableObjectFormFields } from './FormFields';
import { PatientUploadOutputContent } from './OutputContent';
import { GetNotableObjectDocumentation } from './documentation';
import { type BlockConfigProps } from '../../types';

export const getNotableObjectConfig: BlockConfigProps<
  api.FlowDefinition.GetNotableObjectBlock['config']
> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'GetNotableObject',
  defaultConfig: {
    notableObject: FlowNotableObject.ReferenceTable,
    referenceTableId: '',
  },
  configFields: {
    schema: api.FlowDefinition.GetNotableObjectConfigSchema,
    FormFields: GetNotableObjectFormFields,
  },
  documentationMarkdown: GetNotableObjectDocumentation,
  OutputContentComponent: PatientUploadOutputContent,
};
